var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelDetailCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 465,
    height: 141
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__n",
    x1: "56.415%",
    x2: "43.585%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "39.687%",
    y2: "60.313%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__c",
    x1: "100%",
    x2: "0%",
    y1: "49.665%",
    y2: "50.335%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__d",
    x1: "4.988%",
    x2: "96.044%",
    y1: "26.094%",
    y2: "87.574%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FE7230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.132%",
    stopColor: "#DC602D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FD7230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__f",
    x1: "4.988%",
    x2: "95.041%",
    y1: "49.809%",
    y2: "50.275%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E16A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.132%",
    stopColor: "#DA5C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E16A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__h",
    x1: "100%",
    x2: "0%",
    y1: "14.378%",
    y2: "85.622%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__j",
    x1: "99.75%",
    x2: ".25%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__k",
    x1: "99.75%",
    x2: ".25%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__l",
    x1: "99.75%",
    x2: ".25%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__m",
    x1: "4.988%",
    x2: "294.902%",
    y1: "47.064%",
    y2: "55.749%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B14715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.132%",
    stopColor: "#DA5C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#AE4513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__b",
    x1: "100%",
    x2: "0%",
    y1: "48.452%",
    y2: "51.548%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__o",
    x1: "4.988%",
    x2: "95.041%",
    y1: "49.6%",
    y2: "50.576%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E16A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.132%",
    stopColor: "#DA5C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E16A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__p",
    x1: "100%",
    x2: "0%",
    y1: "49.017%",
    y2: "50.983%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__q",
    x1: "49.868%",
    x2: "50.721%",
    y1: "24.462%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B14715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.132%",
    stopColor: "#DA5C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#AE4513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__r",
    x1: "4.988%",
    x2: "294.902%",
    y1: "43.91%",
    y2: "61.923%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B14715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43.132%",
    stopColor: "#DA5C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#AE4513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__s",
    x1: "63.286%",
    x2: "36.714%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__t",
    x1: "100%",
    x2: "0%",
    y1: "49.566%",
    y2: "50.434%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-cancelled_svg__u",
    x1: "100%",
    x2: "0%",
    y1: "49.659%",
    y2: "50.341%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-cancelled_svg__e",
    d: "M.138.518h130.118v11.259H.138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-cancelled_svg__i",
    d: "M.599.172h42.559v35.922H.599z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__a)",
    d: "M224.403 140.736c2.522-21.405 15.271-32.108 38.247-32.108 34.462 0 37.293-30.343 60.466-42.301 23.174-11.96 31.788 7.892 57.004-9.966 25.215-17.857 43.8-33.152 70.92-19.186 18.08 9.31 17.813 43.773-.8 103.388l-225.837.173z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__b)",
    d: "M151.791 7c5.982 0 11.128 3.576 13.417 8.707a7.89 7.89 0 015.197-1.943 7.92 7.92 0 017.14 4.488 5.875 5.875 0 012.08-.378 5.867 5.867 0 015.79 4.923c.737.665 1.592 1.41 2.565 2.236 3.414 2.897 15.4 4.421 35.96 4.573l-44.261-.001-.055.001h-.055l-9.102-.001-.062.001h-.062l-36.773-.001-.061.001h-38.05c12.911-.381 23.392-1.566 31.443-3.552a7.92 7.92 0 0111.563-10.548C140.798 10.483 145.888 7 151.791 7z",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__c)",
    d: "M129.12 106.908c59.522-2.046 117.24-11.812 201.975 9.512 56.49 14.215 100.791 22.375 132.905 24.48H0c46.4-21.298 89.44-32.628 129.12-33.992z",
    opacity: 0.33,
    transform: "matrix(-1 0 0 1 464 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C45020",
    strokeWidth: 0.924,
    d: "M194.895 73.373c13.569 7.58 26.805 8.767 39.708 3.561m-39.708-10.03c13.569 7.58 26.805 8.768 39.708 3.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 0.749,
    d: "M294.85 25.189h-13.438v21.489h13.438v-21.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__d)",
    d: "M8.586 9.83h122.44v118.463H8.586z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#684100",
    d: "M226.906 9.841h122.44v12.671h-122.44z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.929 8.328)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hotel-detail-cancelled_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hotel-detail-cancelled_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hotel-detail-cancelled_svg__f)",
    xlinkHref: "#hotel-detail-cancelled_svg__e"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#F1A324",
    strokeWidth: 2.218,
    mask: "url(#hotel-detail-cancelled_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.669 3.316H147.05"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#F1A324",
    strokeWidth: 2.218,
    mask: "url(#hotel-detail-cancelled_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.669 7.937H147.05"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hotel-detail-cancelled_svg__h)",
    opacity: 0.9,
    xlinkHref: "#hotel-detail-cancelled_svg__i",
    transform: "translate(266.253 92.211)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M266.852 92.382h42.559v7.121h-42.559z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    transform: "translate(229.414 101.473)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.429,
    cy: 10.153,
    fill: "url(#hotel-detail-cancelled_svg__j)",
    rx: 9.126,
    ry: 9.149
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.471,
    cy: 10.821,
    fill: "url(#hotel-detail-cancelled_svg__k)",
    rx: 7.916,
    ry: 7.936
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.555,
    cy: 11.077,
    fill: "url(#hotel-detail-cancelled_svg__l)",
    rx: 5.817,
    ry: 5.832
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.468,
    cy: 12.925,
    fill: "url(#hotel-detail-cancelled_svg__j)",
    rx: 9.126,
    ry: 9.149
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.51,
    cy: 8.048,
    fill: "url(#hotel-detail-cancelled_svg__k)",
    rx: 7.916,
    ry: 7.936
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.594,
    cy: 11.077,
    fill: "url(#hotel-detail-cancelled_svg__l)",
    rx: 5.817,
    ry: 5.832
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__m)",
    d: "M9.848 112.043h38.684v16.25H.607v-7.01a9.24 9.24 0 019.24-9.24zm81.242 0h38.685a9.24 9.24 0 019.24 9.24v7.01H91.092v-16.25z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#684100",
    d: "M270.17 22.33h1.844v68.383h-1.844zm34.106 0h1.844v68.383h-1.844z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__n)",
    d: "M53.012 2.131h33.599v93.801H53.012z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__o)",
    d: "M49.11.663h41.403v5.181H49.11z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M276.623 88.865h22.123v1.848h-22.123z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__p)",
    d: "M44.415 90.382h50.782v7.121H44.415z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDAA0",
    d: "M276.576 106.922h23.857v21.382h-23.857z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EA682F",
    strokeWidth: 0.749,
    d: "M288.076 106.922v21.382"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__q)",
    d: "M5.922.385h3.559v65.61H5.922z",
    transform: "translate(187 60.429)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__r)",
    d: "M1.76 62.629h11.354v5.545H1.76z",
    transform: "translate(187 60.429)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C45020",
    strokeWidth: 0.924,
    d: "M187.035 72.167h14.474M189.801 65.9h10.139"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M242.704 35.979h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M243.866 35.979h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    opacity: 0.9,
    transform: "translate(240.011 34.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBA2",
    d: "M243.866 35.979h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "translate(240.992 35.409)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.992 35.409h15.269v1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "translate(240.011 34.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.011 34.096h17.231v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 240.992 54.403)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.992 54.403h15.269v-1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 240.011 55.716)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.011 55.716h17.231v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M321.862 35.979h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M323.024 35.979h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    opacity: 0.9,
    transform: "translate(319.169 34.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBA2",
    d: "M323.024 35.979h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "translate(320.15 35.409)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M320.15 35.409h15.269v1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "translate(319.169 34.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M319.169 34.096H336.4v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 320.15 54.403)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M320.15 54.403h15.269v-1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 319.169 55.716)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M319.169 55.716H336.4v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M242.704 65.736h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M243.866 65.736h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    opacity: 0.9,
    transform: "translate(240.011 63.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBA2",
    d: "M243.866 65.736h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "translate(240.992 65.166)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.992 65.166h15.269v1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "translate(240.011 63.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.011 63.853h17.231v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 240.992 84.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.992 84.16h15.269v-1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 240.011 85.473)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M240.011 85.473h17.231v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M321.862 65.736h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M323.024 65.736h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    opacity: 0.9,
    transform: "translate(319.169 63.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBA2",
    d: "M323.024 65.736h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "translate(320.15 65.166)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M320.15 65.166h15.269v1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "translate(319.169 63.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M319.169 63.853H336.4v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__t)",
    d: "M0 0h15.269v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 320.15 84.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M320.15 84.16h15.269v-1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-cancelled_svg__u)",
    d: "M0 0h17.231v1.422H0z",
    opacity: 0.9,
    transform: "matrix(1 0 0 -1 319.169 85.473)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M319.169 85.473H336.4v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6652E",
    d: "M282.153 49.727h11.946v17.315h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBA2",
    d: "M282.153 49.727h11.946v8.658h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M281.188 49.727h13.875v1.332h-13.875zm0 16.649h13.876v1.332h-13.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6652E",
    d: "M282.153 18.496h11.946v17.315h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBA2",
    d: "M282.153 18.496h11.946v8.658h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7591C",
    d: "M281.188 18.496h13.875v1.332h-13.875zm0 16.649h13.876v1.332h-13.876z"
  })))));
}
export default SvgHotelDetailCancelled;